import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoInner = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 300 300",
	style: { enableBackground: "new 0 0 300 300" },
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Layer_2_00000138558985285725151510000015314366222885839550_",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M167.8 104.8c0-9.8-8-17.8-17.8-17.8s-17.8 8-17.8 17.8 8 17.8 17.8 17.8 17.8-8 17.8-17.8z"
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "currentColor",
				cx: 107.6,
				cy: 136.3,
				r: 17.8
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "currentColor",
				cx: 192.4,
				cy: 136.3,
				r: 17.8
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				d: "M176.4 167.7c-9.9 0-17.8 8-17.8 17.8 0 9.9 8 17.8 17.8 17.8s17.8-8 17.8-17.8c0-9.9-8-17.8-17.8-17.8zM123.6 167.7c-9.8 0-17.8 8-17.8 17.8 0 9.9 8 17.8 17.8 17.8s17.8-8 17.8-17.8c0-9.9-7.9-17.8-17.8-17.8z"
			})
		]
	})
});
export { SvgLogoInner as ReactComponent };
